import React, { useState, useEffect } from "react";
import styled from "styled-components";
import alarmSvg from "../../assets/images/alarm.svg";
import userAvi from "../../assets/images/dummyAvi.svg";
import { RxCaretDown } from "react-icons/rx";
import addService from "../../assets/images/add_service.svg";
import rateServices from "../../assets/images/rate_services.svg";
import { useNavigate, Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { FiPackage, FiMinus } from "react-icons/fi";
import { toast } from "react-hot-toast";

const Home = () => {
  const navigate = useNavigate();
  const name = JSON.parse(sessionStorage?.getItem("name"));
  const [loading, setLoading] = useState(false);
  const [services, setServices] = useState([]);
  const [updatingService, setUpdatingService] = useState(false);
  const token = JSON.parse(sessionStorage.getItem("token"));
  const clientId = JSON.parse(sessionStorage.getItem("clientId2"));

  useEffect(() => {
    fetchAllowedServices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatServiceName = (service) => {
    // Replace hyphens with spaces and capitalize first letter
    return service
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const fetchAllowedServices = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `https://services.tm30.net/manager/v1/client/allowedServices/${clientId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (data.message === "Success") {
        setServices(data.data || []);
      } else {
        console.error("Failed to fetch services:", data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching services:", error);
      setLoading(false);
    }
  };
  
  const toggleService = async (serviceToToggle) => {
    try {
      setUpdatingService(serviceToToggle);
      
      // Since this is the Home page, we're only removing services
      // Use DELETE method for removing a service
      const response = await fetch(
        `https://services.tm30.net/manager/v1/client/allowedServices/${clientId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            allowedServices: [serviceToToggle],
          }),
        }
      );
      
      const data = await response.json();
      if (data.message === "Success") {
        toast.success("Service removed");
        // Update local state after successful API call
        setServices(prev => prev.filter(service => service !== serviceToToggle));
      } else {
        toast.error(data.message || "Failed to remove service");
        console.error("Failed to remove service:", data);
      }
      
      setUpdatingService(false);
    } catch (error) {
      toast.error("Error removing service");
      console.error("Error removing service:", error);
      setUpdatingService(false);
    }
  };

  return (
    <Container>
      <div className="head">
        <div className="head_content">
          <img src={alarmSvg} alt="" />
          <div
            className="userProfileWrapper"
            onClick={() => {
              navigate("/dashboard/profile-settings");
            }}
          >
            <img src={userAvi} alt="" />
            <div className="userInfo">
              <p style={{ fontWeight: "bold" }}>{name}</p>
              <p style={{ fontSize: "11px", fontWeight: "bold" }}>User</p>
            </div>
            <RxCaretDown size={17} style={{ color: "#fff" }} />
          </div>
        </div>
      </div>
      <div className="contentWrapper">
        <div className="firstContentHead">
          <p className="pageName">Services</p>
        </div>
        <div className="header">
          <p>This is a list of all your active services</p>
          <Link to="/add-services">
            <img src={addService} alt="" />
          </Link>
        </div>
        <div className="services">
          {loading ? (
            <div className="loading-container">
              <Skeleton count={5} height={50} style={{ marginBottom: "10px" }} />
            </div>
          ) : services && services.length > 0 ? (
            <ul>
              {services.map((service, index) => (
                <React.Fragment key={index}>
                  <li className="service-item">
                    <div className="service-content">
                      <div className="service-icon">
                        <FiPackage size={20} />
                      </div>
                      <div className="service-details">
                        <span className="service-name">{formatServiceName(service)}</span>
                      </div>
                    </div>
                    <div className="service-action">
                      <button 
                        className={`action-button ${updatingService === service ? 'updating' : ''}`}
                        onClick={() => !updatingService && toggleService(service)}
                        disabled={updatingService}
                      >
                        {updatingService === service ? (
                          <div className="loading-spinner"></div>
                        ) : (
                          <>
                            <FiMinus size={16} />
                            Remove
                          </>
                        )}
                      </button>
                    </div>
                  </li>
                  {index < services.length - 1 && <hr />}
                </React.Fragment>
              ))}
            </ul>
          ) : (
            <div className="empty-state">
              <FiPackage size={50} color="#ccc" />
              <h3>No Services Available</h3>
              <p>You don't have any services added yet. Click on "Add Service" to get started.</p>
              <Link to="/add-services" className="add-service-btn">
                Add Service
              </Link>
            </div>
          )}
        </div>

        <div className="rateService">
          <img src={rateServices} alt="" />
        </div>
      </div>
    </Container>
  );
};

export default Home;

const Container = styled.div`
  padding: 30px;
  position: absolute;
  top: 0;
  width: calc(100% - 16%);
  max-width: calc(100% - 16%);

  @media only screen and (max-width: 1147px) {
    width: calc(100%);
    margin-left: 0;
    max-width: calc(100%);
  }
  @media only screen and (max-width: 450px) {
    padding: 0;
  }
  .head {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .head_content {
      display: flex;
      width: 300px;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;

      @media only screen and (max-width: 450px) {
        width: 150px;
      }

      img {
        @media only screen and (max-width: 450px) {
          width: 20px;
        }
      }

      .userProfileWrapper {
        width: 200px;
        border-left: 1px solid #eeebeb;
        padding-left: 40px;
        display: flex;
        align-items: center;
        gap: 15px;
        cursor: pointer;

        @media only screen and (max-width: 450px) {
          width: 100px;
          padding-left: 0;
          margin-top: 20px;
          border-left: 0 solid #eeebeb;
          /* flex-direction: column; */
        }

        .userInfo {
          display: flex;
          flex-direction: column;
          gap: 15px;
          color: #fff;
          /* align-items: center; */

          p {
            @media only screen and (max-width: 450px) {
              font-size: 11px;
            }
          }
        }
        img {
          @media only screen and (max-width: 450px) {
            width: 40px;
          }
        }

        svg {
          @media only screen and (max-width: 450px) {
            display: none;
          }
        }
      }
    }
  }

  .contentWrapper {
    background-color: #fff;
    padding: 20px 0 80px;
    border-radius: 20px;
    margin-top: 50px;

    .firstContentHead {
      display: flex;
      align-items: center;
      padding: 20px;
      justify-content: space-between;
      .pageName {
        font-size: 30px;
        @media only screen and (max-width: 450px) {
          font-size: 18px;
        }
      }
      .filterWrapper {
        display: flex;
        align-items: center;
        gap: 15px;

        select {
          border: 1px solid #00000047;
          border-radius: 5px;
          padding: 5px;
        }
      }
    }

    .header {
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      @media only screen and (max-width: 450px) {
        padding: 0 20px;
      }

      img {
        width: 200px;
        @media only screen and (max-width: 450px) {
          width: 140px;
        }
      }
      p {
        margin-left: 30px;
        font-weight: 500;
        font-size: 17px;
        @media only screen and (max-width: 450px) {
          margin-left: 0;
          font-size: 12px;
        }
      }
    }

    .services {
      margin: 30px 0;
      padding: 0 20px;
      
      .loading-container {
        padding: 0 55px;
      }
      
      ul {
          li.service-item {
          padding: 20px 0;
          margin: 0 55px;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          transition: all 0.3s ease;
          
          &:hover {
            background-color: #f9f9f9;
          }
          
          .service-content {
            display: flex;
            align-items: center;
            gap: 15px;
          }
          
          .service-icon {
            background-color: #f0f0f0;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #333;
          }
          
          .service-details {
            display: flex;
            flex-direction: column;
            
            .service-name {
              font-weight: 600;
              color: #333;
            }
            
            .service-description {
              font-size: 14px;
              color: #666;
              margin-top: 5px;
            }
          }
          
          .service-action {
            .action-button {
              display: flex;
              align-items: center;
              gap: 6px;
              padding: 8px 12px;
              border-radius: 6px;
              font-size: 14px;
              font-weight: 500;
              cursor: pointer;
              transition: all 0.2s ease;
              background-color: #f44336;
              color: white;
              border: none;
              
              &:hover:not(:disabled) {
                background-color: #d32f2f;
              }
              
              &:disabled, &.updating {
                opacity: 0.7;
                cursor: not-allowed;
              }
              
              .loading-spinner {
                width: 16px;
                height: 16px;
                border: 2px solid rgba(255, 255, 255, 0.3);
                border-radius: 50%;
                border-top-color: white;
                animation: spin 1s linear infinite;
              }
              
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            }
          }
          
          @media only screen and (max-width: 450px) {
            font-size: 14px;
            margin: 0 20px;
            padding: 15px 0;
            
            .service-icon {
              width: 30px;
              height: 30px;
            }
          }
        }
        
        hr {
          margin: 0 55px;
          border: none;
          border-top: 1px solid #eee;
          
          @media only screen and (max-width: 450px) {
            margin: 0 20px;
          }
        }
      }
      
      .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 50px 20px;
        text-align: center;
        
        h3 {
          margin: 20px 0 10px;
          color: #333;
        }
        
        p {
          color: #666;
          max-width: 400px;
          margin-bottom: 20px;
        }
        
        .add-service-btn {
          background-color: #007bff;
          color: white;
          padding: 10px 20px;
          border-radius: 5px;
          text-decoration: none;
          font-weight: 600;
          transition: background-color 0.3s ease;
          
          &:hover {
            background-color: #0069d9;
          }
        }
      }
    }

    .rateService {
      display: flex;
      justify-content: center;
      padding: 40px 0;

      img {
        width: 380px;
        /* height: 30px; */
        cursor: pointer;
        @media only screen and (max-width: 450px) {
          width: 240px;
        }
      }
    }
  }
`;
